"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhone = void 0;
function formatPhone(phone) {
    const phoneNum = phone.replace(/[^\d]/g, "");
    if (phoneNum.length !== 11 || (phoneNum[0] !== "7" && phoneNum[0] !== "8")) {
        return undefined;
    }
    const phoneCorrect = `+7 (${phoneNum.substring(1, 4)}) ${phoneNum.substring(4, 7)} ${phoneNum.substring(7, 9)} ${phoneNum.substring(9)}`;
    return phoneCorrect;
}
exports.formatPhone = formatPhone;
//# sourceMappingURL=formatPhone.js.map